import darkLogo from '../../../../assets/images/logo_dark_bg.png';
import lightLogo from '../../../../assets/images/logo_light_bg.png';
import transparentLogo from '../../../../assets/images/logo_transparent_bg.png';

type LogoProps = {
  variant?: 'dark' | 'light' | 'transparent';
  className?: string;
};

export const Logo = ({ variant = 'transparent', className = 'h-10 w-auto' }: LogoProps) => {
  const src = variant === 'dark' ? darkLogo : variant === 'light' ? lightLogo : transparentLogo;
  return <img src={src} alt="ADarveo" className={className} />;
};
